<template>
  <div class="newsList" ref="container">
    <Tabs
      @click="onClick"
      class="newsSwitch"
      line-height="0.04rem"
      line-width="0.24rem"
      color="#e93323"
      v-model="active"
      animated
      title-inactive-color="2"
      nav-right="0.46rem"
      sticky
    >
      <Tab
        v-for="(item, index) in navLsit"
        :key="index"
        :title="item.title"
        title-inactive-color="#999"
        title-active-color="#282828"
      >
        <div class="list" v-for="(item, index) in articleList" :key="index">
          <router-link
            :to="{ path: '/law_detail/' + item.id }"
            class="item acea-row row-between-wrapper"
            v-if="item.image_input.length === 1"
          >
            <template v-if="item.image_input[0] != ''">
              <div class="text acea-row row-column-between">
                <div class="name line3">{{ item.title }}</div>
                <div>
                  <span class="stick_label space" v-if="item.is_top == 1"
                    >置顶</span
                  >
                  <span v-if="item.author != ''">{{ item.author }}&nbsp;</span
                  ><span
                    >浏览&nbsp;{{ item.visit }}&nbsp;{{ item.add_time }}</span
                  >
                </div>
              </div>
              <div class="pictrue"><img :src="item.image_input[0]" /></div>
            </template>
            <template v-else>
              <div class="item_detail">
                <h3 class="item_title">{{ item.title }}</h3>
                <div class="item_info">
                  <div>
                    <span class="stick_label space" v-if="item.is_top == 1"
                      >置顶&nbsp;</span
                    >
                    <span class="src space" v-if="item.author != ''">{{
                      item.author
                    }}</span>
                    <span class="cmt space">浏览&nbsp;{{ item.visit }}</span>
                    <span class="space" :title="item.add_time">{{
                      item.add_time
                    }}</span>
                  </div>
                </div>
              </div>
            </template>
          </router-link>
          <router-link
            :to="{ path: '/law_detail/' + item.id }"
            class="item"
            v-if="item.image_input.length === 2"
          >
            <div class="title line1">
              {{ item.title }}
            </div>
            <div class="picList acea-row row-between-wrapper">
              <div
                class="pictrue"
                v-for="(itemImg, index) in item.image_input"
                :key="index"
              >
                <img :src="itemImg" />
              </div>
            </div>
            <div class="time">{{ item.add_time }}</div>
          </router-link>
          <router-link
            :to="{ path: '/law_detail/' + item.id }"
            class="item"
            v-if="item.image_input.length === 3"
          >
            <div class="title line1">
              {{ item.title }}
            </div>
            <div class="picList on acea-row row-between-wrapper">
              <div
                class="pictrue"
                v-for="(itemImg, index) in item.image_input"
                :key="index"
              >
                <img :src="itemImg" />
              </div>
            </div>
            <div class="time">{{ item.add_time }}</div>
          </router-link>
        </div>
        <Loading
          :loaded="loadend"
          :loading="loading"
          v-if="index > 0 && articleList.length > 0"
        ></Loading>
        <!--暂无新闻-->
        <div class="noCommodity" v-if="articleList.length === 0 && page >= 1">
          <div class="van-empty">
            <div class="van-empty__image">
              <img src="@assets/images/empty-image-default.png" />
            </div>
            <p class="van-empty__description">暂无信息</p>
          </div>
        </div>
      </Tab>
    </Tabs>
  </div>
</template>
<script>
import "@assets/css/swiper.min.css";
import { Tab, Tabs } from "vant";
import { getLawCategory, getLawHotList, getLawList } from "@api/public";
import Loading from "@components/Loading";

export default {
  name: "NewsList",
  components: {
    Tab,
    Tabs,
    Loading
  },
  props: {},
  data: function() {
    return {
      page: 1,
      limit: 20,
      loadTitle: "",
      loading: false,
      loadend: false,
      imgUrls: [],
      navLsit: [],
      articleList: [],
      active: this.$route.params.tab ? parseInt(this.$route.params.tab) : 0,
      cid: 0,
      swiperNew: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      }
    };
  },
  mounted: function() {
    // this.articleBanner();
    this.articleCategory();
    // this.articleHotList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getLawLists();
    });
  },
  methods: {
    articleCategory: function() {
      let that = this;
      getLawCategory().then(res => {
        that.navLsit = res.data;
        that.cid = that.active == 0 ? 0 : that.navLsit[that.active].id;
        that.getLawLists();
      });
    },
    articleHotList: function() {
      let that = this;
      getLawHotList().then(res => {
        that.articleList = res.data;
      });
    },
    getLawLists: function() {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      let q = {
        page: that.page,
        limit: that.limit
      };
      getLawList(q, that.cid).then(res => {
        that.loading = false;
        //apply();js将一个数组插入另一个数组;
        that.articleList.push.apply(that.articleList, res.data);
        that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
        that.page = that.page + 1;
      });
    },
    onClick: function(name) {
      if (name === 0) {
        this.cid = 0;
      } else {
        this.cid = this.navLsit[name].id;
      }
      this.articleList = [];
      this.page = 1;
      this.loadend = false;
      this.loading = false;
      this.getLawLists();
    }
  }
};
</script>
<style scoped>
.item_detail,
.item_detail2 {
  padding: 0;
  margin: 0;
}
.item_detail .item_title {
  line-height: 0.5rem;
  overflow: hidden;
  font-size: 0.34rem;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  font-weight: 450;
}
.item_detail .item_info {
  margin-top: 0.15rem;
  color: #999;
  overflow: hidden;
  font-size: 0.25rem;
}
.item_detail .item_info .space {
  margin-right: 0.15rem;
  display: inline-block;
  vertical-align: middle;
}
.stick_label {
  color: #f85959;
  border-color: rgba(248, 89, 89, 0.5);
  border-radius: 0.05rem;
  text-align: center;
}
.van-empty {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0.5rem 0;
}
.van-empty__image {
  height: 4rem;
  width: 4rem;
}
.van-empty__image img {
  width: 100%;
  height: 100%;
}
.van-empty__description {
  width: 100%;
  text-align: center;
  margin-top: 0.2rem;
  color: #9e9e9e;
  font-size: 0.3rem;
}
</style>
